const fileToString = (file: File): Promise<string> => new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = (readerError) => reject(readerError);
});

export const adaptPictureFile = async (files: File[]): Promise<{ ImageContentBase64: string; size: number; extension: string | undefined }> => {
    try {
        const file = files?.[0];
        const fileString = await fileToString(file);
        const splits = fileString.split(';base64,');
        const extension = file.name.split('.').pop();

        return {
            ImageContentBase64: splits[1],
            size: file.size,
            extension,
        };
    } catch (error) {
        throw error;
    }
};
